<template>
  <el-dialog v-if="dialogVisible" v-el-drag-dialog :title="$tx('hygl.components.selectMeeting', '选择议题')" :visible.sync="dialogVisible" width="1200px" :close-on-click-modal="false" :destroy-on-close="true" @close="toClose">
    <el-form :model="vo" @submit.native.prevent>
      <div style="width:100%;" class="el-table el-table--fit el-table--border">
        <div class="el-table__body-wrapper">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body ">
            <tbody>
              <tr v-if="false">
                <td ref="tdlbl_登记人" class="el-table__cell tdlbl tdw17" colspan="1">

                  <span v-field-lbl="'creator'" class="field">登记人</span>
                </td>
                <td class="el-table__cell tdcont tdw33" colspan="2">
                  <form-item ref="creator" :field="{'defaultValue':null,'elementCanEdit':'0','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入申请人','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'登记人','propName':'creator','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.creator','option':[],'autocomplete':'off','showWordLimit':false}" :vo="vo" :can-edit="canEdit" />
                </td>
                <td ref="tdlbl_创建时间" class="el-table__cell tdlbl tdw17" colspan="1">

                  <span v-field-lbl="'createDate'" class="field">创建时间</span>
                </td>
                <td class="el-table__cell tdcont tdw33" colspan="2">
                  <form-item ref="createDate" :field="{'defaultValue':null,'elementCanEdit':'0','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'format：yyyy年MM月dd日\r\n','elementReadonly':1,'elementType':'date','emptyMessage':'请输入申请日期 ','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'创建时间','propName':'createDate','propType':'java.util.Date','textFormatter':'yyyy-MM-dd HH:mm','valueMaxLength':null,'valueMinLength':null,'model':'vo.createDate','option':[],'weekday':0,'stepNum':5}" :vo="vo" :can-edit="canEdit" />
                </td>
              </tr>
              <tr>
                <td ref="tdlbl_会议议题" class="el-table__cell tdlbl tdw17" colspan="1">
                  <span class="required">*</span>
                  <span v-field-lbl="'subject'" class="field">会议议题</span>
                </td>
                <td class="el-table__cell tdcont tdw83" colspan="5">
                  <form-item ref="subject" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入会议议题','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'会议议题','propName':'subject','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.subject','option':[],'autocomplete':'off','showWordLimit':false}" :vo="vo" :can-edit="canEdit" />
                </td>
              </tr>
              <tr>
                <td ref="tdlbl_会议类型" class="el-table__cell tdlbl tdw17" colspan="1">
                  <span class="required">*</span>
                  <span v-field-lbl="'subjectTypeName'" class="field">会议类型</span>
                </td>
                <td class="el-table__cell tdcont tdw33" colspan="2">
                  <form-item ref="subjectTypeName" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'v：t','elementReadonly':1,'elementType':'select','emptyMessage':'','errorMessage':null,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'会议类型','propName':'subjectTypeName','propType':'String','textFormatter':null,'valueMaxLength':50,'valueMinLength':null,'tbFieldName':'subjecttypename','model':'vo.subjectTypeName','option':[{'value':'v','name':'t'}],'formTdAlign':'text-left','optionGenerateType':1,'clearable':true,'filterable':false,'allowCreate':false}" :vo="vo" :can-edit="canEdit" />
                </td>
                <td ref="tdlbl_主办部门" class="el-table__cell tdlbl tdw17" colspan="1">
                  <span class="required">*</span>
                  <span v-field-lbl="'mainDept'" class="field">主办部门</span>
                </td>
                <td class="el-table__cell tdcont tdw33" colspan="2">
                  <form-item ref="mainDept" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':1,'elementType':'input','emptyMessage':'请输入主办部门','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'主办部门','propName':'mainDept','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.mainDept','option':[],'autocomplete':'off','showWordLimit':false,'dialog':1,'dialogType':'suborg','dialogOrgLevel':'2'}" :vo="vo" :can-edit="canEdit" />
                </td>
              </tr>
              <tr>
                <td ref="tdlbl_陈述时间（分钟）" class="el-table__cell tdlbl tdw17" colspan="1">
                  <span class="required">*</span>
                  <span v-field-lbl="'reportTime'" class="field">陈述时间（分钟）</span>
                </td>
                <td class="el-table__cell tdcont tdw33" colspan="2">
                  <form-item ref="reportTime" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入汇报时间（分钟）','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'陈述时间（分钟）','propName':'reportTime','propType':'Integer','textFormatter':'integer','valueMaxLength':null,'valueMinLength':null,'model':'vo.reportTime','option':[],'autocomplete':'off','showWordLimit':false}" :vo="vo" :can-edit="canEdit" />
                </td>
                <td ref="tdlbl_讨论时间" class="el-table__cell tdlbl tdw17" colspan="1">
                  <span class="required">*</span>
                  <span v-field-lbl="'talkTime'" class="field">讨论时间</span>
                </td>
                <td class="el-table__cell tdcont tdw33" colspan="2">
                  <form-item ref="talkTime" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入讨论时间（分钟）','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'讨论时间','propName':'talkTime','propType':'Integer','textFormatter':'integer','valueMaxLength':null,'valueMinLength':null,'model':'vo.talkTime','option':[],'autocomplete':'off','showWordLimit':false}" :vo="vo" :can-edit="canEdit" />
                </td>
              </tr>
              <tr>
                <td ref="tdlbl_陈述人" class="el-table__cell tdlbl tdw17" colspan="1">
                  <span class="required">*</span>
                  <span v-field-lbl="'reportPersonName'" class="field">陈述人</span>
                </td>
                <td class="el-table__cell tdcont tdw33" colspan="2">
                  <form-item ref="reportPersonName" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':1,'elementType':'input','emptyMessage':'请选择陈述人','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'陈述人','propName':'reportPersonName','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.reportPersonName','option':[],'autocomplete':'off','showWordLimit':false,'dialog':1,'dialogType':'staff','dialogOrgLevel':'','dialogSelectedOrderBy':'orgOrderNo','dialogMultiple':false,'dialogOrgSelf':false}" :vo="vo" :can-edit="canEdit" />
                </td>
                <td ref="tdlbl_是否PPT演示" class="el-table__cell tdlbl tdw17" colspan="1">

                  <span v-field-lbl="'isPpt'" class="field">是否PPT演示</span>
                </td>
                <td class="el-table__cell tdcont tdw33" colspan="2">
                  <form-item ref="isPpt" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'1：是\n0：否','elementReadonly':1,'elementType':'radio','emptyMessage':'请选择是否PPT演示','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'是否PPT演示','propName':'isPpt','propType':'Short','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'model':'vo.isPpt','option':[{'value':'1','name':'是'},{'value':'0','name':'否'}],'optionGenerateType':0,'clearable':true,'filterable':false,'allowCreate':false}" :vo="vo" :can-edit="canEdit" />
                </td>
              </tr>
              <tr>
                <td ref="tdlbl_固定列席部门" class="el-table__cell tdlbl tdw17" colspan="1">

                  <span v-field-lbl="'isAttendDept'" class="field">相关部门列席</span>
                </td>
                <td class="el-table__cell tdcont tdw33" colspan="2">
                  <form-item ref="isAttendDept" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'1：是\n0：否','elementReadonly':1,'elementType':'radio','emptyMessage':'请选择是否相关部门列席','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'相关部门列席','propName':'isAttendDept','propType':'Short','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'model':'vo.isAttendDept','option':[{'value':'1','name':'是'},{'value':'0','name':'否'}],'optionGenerateType':0,'clearable':true,'filterable':false,'allowCreate':false}" :vo="vo" :can-edit="canEdit" />
                </td>
                <td ref="tdlbl_书面通报" class="el-table__cell tdlbl tdw17" colspan="1">

                  <span v-field-lbl="'isWritten'" class="field">携带纸质材料</span>
                </td>
                <td class="el-table__cell tdcont tdw33" colspan="2">
                  <div style="display: flex;align-items: center;">
                    <div>
                      <form-item ref="isWritten" :field="{'defaultValue':null,'elementCanEdit':'{${curTN.tnCanEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'1：是\n0：否','elementReadonly':1,'elementType':'radio','emptyMessage':'','errorMessage':null,'formTdAlign':'text-left','formTdColspan':12,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'携带纸质材料','propName':'isWritten','propType':'Short','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'model':'vo.isWritten','option':[{'value':'1','name':'是'},{'value':'0','name':'否'}],'tbFieldName':'iswritten','optionGenerateType':0,'clearable':true,'filterable':false,'allowCreate':false}" :vo="vo" :can-edit="canEdit" />		</div>
                    <span v-if="vo.isWritten==1&& $i18n.locale==='zhCN'" style="margin-left: 15px;color:red;width: calc(100% - 115px);line-height: 19px;">{{ $tx('hygl.ytjy.isWrittenTip') }}</span>
                    <span v-if="vo.isWritten==1&& $i18n.locale==='en'" style="margin-left: 15px;color:red;width: calc(100% - 140px);line-height: 19px;">{{ $tx('hygl.ytjy.isWrittenTip') }}</span>
                  </div>
                </td>
              </tr>
              <tr v-if="vo.isAttendDept==1" :key="10211">
                <td ref="tdlbl_列席部门" class="el-table__cell tdlbl tdw17" colspan="1">
                  <span class="required">*</span>
                  <span v-field-lbl="'attendDept'" class="field">列席部门</span>
                </td>
                <td class="el-table__cell tdcont tdw83" colspan="5">
                  <form-item ref="attendDept" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入列席部门','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'列席部门','propName':'attendDept','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.attendDept','option':[],'autocomplete':'off','showWordLimit':false,'dialog':1,'dialogType':'suborg','dialogOrgLevel':'2','dialogMultiple':true}" :vo="vo" :can-edit="canEdit" />
                </td>
              </tr>
              <tr v-if="show" :key="10012">
                <td ref="tdlbl_随议题列席人员" class="el-table__cell tdlbl tdw17" colspan="1">
                  <span class="required">*</span>
                  <span v-field-lbl="'attendStoolName'" class="field">随议题列席人员</span>
                </td>
                <td class="el-table__cell tdcont tdw83" colspan="5">
                  <form-item ref="attendStoolName" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入随议题列席人员','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'随议题列席人员','propName':'attendStoolName','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.attendStoolName','option':[],'autocomplete':'off','showWordLimit':false,'dialog':1,'dialogType':'staff','dialogOrgLevel':'','dialogSelectedOrderBy':'orgOrderNo','dialogMultiple':true,'dialogOrgSelf':false,'dialogOnlyCurSys':true}" :vo="vo" :can-edit="canEdit" />
                </td>
              </tr>
              <tr>
                <td ref="tdlbl_排序号" class="el-table__cell tdlbl tdw17" colspan="1">
                  <span class="required">*</span>
                  <span v-field-lbl="'orderNo'" class="field">排序号</span>
                </td>
                <td class="el-table__cell tdcont tdw83" colspan="5">
                  <form-item ref="orderNo" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入排序','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'排序号','propName':'orderNo','propType':'String','textFormatter':'textfield','valueMaxLength':null,'valueMinLength':null,'model':'vo.orderNo','option':[],'autocomplete':'off','showWordLimit':false}" :vo="vo" :can-edit="canEdit" />
                </td>
              </tr>
              <tr>
                <td ref="tdlbl_决策建议" class="el-table__cell tdlbl tdw17" colspan="1">
                  <span class="required">*</span>
                  <span v-field-lbl="'resolution'" class="field">决策建议</span>
                </td>
                <td class="el-table__cell tdcont tdw83" colspan="5">
                  <form-item ref="resolution" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':70,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'textarea','emptyMessage':'请输入决策建议','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'决策建议','propName':'resolution','propType':'String','textFormatter':'textarea','valueMaxLength':null,'valueMinLength':null,'model':'vo.resolution','option':[],'autosize':false}" :vo="vo" :can-edit="canEdit" :autosize="false" />
                </td>
              </tr>
              <tr>
                <td ref="tdlbl_备注" class="el-table__cell tdlbl tdw17" colspan="1">

                  <span v-field-lbl="'remark'" class="field">备注</span>
                </td>
                <td class="el-table__cell tdcont tdw83" colspan="5">
                  <form-item ref="remark" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'textarea','emptyMessage':'请输入备注','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'备注','propName':'remark','propType':'String','textFormatter':'textarea','valueMaxLength':null,'valueMinLength':null,'model':'vo.remark','option':[],'autocomplete':'off','showWordLimit':false,'autosize':false}" :vo="vo" :can-edit="canEdit" :autosize="false" />
                </td>
              </tr>
              <tr>
                <td ref="tdlbl_附件" class="el-table__cell tdlbl tdw17">

                  <span v-field-lbl="''" class="field">附件</span>
                </td>
                <td class="el-table__cell tdcont tdcont" colspan="5">
                  <Attachment
ref="attachments"
                              :vo="vo"
                              :is-required="0"
                              accept="*.*"
                              empty-message=""
                              wf-attach-url="/hygl/ytRecord"
                              :limit-count="10"
                              online-editor=""
                              online-file=""
                              :attachments="vo.passenger.attachments"
                              :attachs-type="'ATTACH'"
                              :is-drag="0"
                              :auto-upload="0"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button v-pageBtn-lbl="'close'" @click="toClose">关 闭</el-button>
      <el-button v-pageBtn-lbl="'save'" :loading="doing" type="primary" @click="submitNoIdHandle">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
    data: function() {
        return {
        	loginUser: this.$store.getters.loginUser,
            dialogVisible: false,
            viewType: 'wapp',
            i18npkg: 'hygl',
            moduleCode: 'ytRecord',
            show: true,
            vo: {},
            canEdit: 1,
            doing: false
        }
    },
    computed: {
    },
    watch: {
        'vo.subjectTypeName': function(val) {
            if (val) {
		 	    this.vo.passenger.subjectTypeNameOptions.forEach(item => {
                    if (item.text === val) {
				   	this.vo.subjectType = item.id
				   }
                })
		    }
        }

    },
    created: function() {
        if (this.$parent.$vnode.context.activeTabIndex) {
            this.activeTabName = this.$parent.$vnode.context.activeTabIndex
        }

	    this.$set(this.$vnode.context, 'wfAttach', false)

        this.viewType = window.vType
        if (!this.vo.creator) {
            this.vo.creator = this.$store.getters.loginUser.personName
        }
        if (!this.vo.creatorId) {
            this.vo.creatorId = this.$store.getters.loginUser.personId
        }
        this.$bus.on('openYtRecordDialogForm', this.openYtRecordDialogForm)
    },
    beforeDestroy: function() {
        this.$bus.off('openYtRecordDialogForm', this.openYtRecordDialogForm)
    },
    mounted: function() {
    },
    methods: {
        openYtRecordDialogForm(row) {
            console.log('row===', row)
            this.vo = row
            this.dialogVisible = true
        },
        onSelectTreeDataLoaded: function(treedata, attr) {
            if (attr.name === 'mainDept') {
                treedata = treedata.filter(item => item.isManageOrg != 1)
            }
            return treedata
        },
        onSelectSuborgCompleted(node, attr) {
            debugger
            const arrName = []
            const ids = []
            node.forEach(item => {
                arrName.push(item.name)
                ids.push(item.id)
            })
            if (attr.name === 'mainDept') {
                this.vo.mainDept = arrName.join('、')
                this.vo.mainDeptId = ids.join(',')
            }

            if (attr.name === 'attendDept') {
                this.vo.attendDept = arrName.join('、')
                this.vo.attendDeptId = ids.join(',')
            }
        },
        onSelectStaffCompleted(node, attr) {
            const arrName = []
            const ids = []
            node.forEach(item => {
                arrName.push(item.name)
                ids.push(item.personId)
            })
            if (attr.name === 'reportPersonName') {
			 this.show = false
                this.vo.reportPersonName = arrName.join('、')
                this.vo.reportPerson = ids.join(',')

          	this.vo.attendStoolName = arrName.join('、')
                this.vo.attendStoolId = ids.join(',')

                setTimeout(() => {
                    this.show = true
                }, 10)
            }

            if (attr.name === 'attendStoolName') {
                this.vo.attendStoolName = arrName.join('、')
                this.vo.attendStoolId = ids.join(',')
            }
        },
        submitNoIdHandle() {
            console.log('this', this)
            //
            // this.formValidate(() => {
            //     this.$emit('submitNoIdHandle', this.vo)
            //     this.dialogVisible = false
            // }, null, 1)
            // return

            this.formValidate(() => {
                this.uploadAttact(this.vo.passenger.attachments, this.vo).then((result) => {
                    console.log('result', result)
                    this.doing = false
                    if (result.code === 'success') {
                        if (result.result.length) {
                            this.vo.passenger.attachments.push(...result.result[0].body.uploadAttachList)
                        }
                        this.vo.passenger.attachments = this.vo.passenger.attachments.filter(item => item.id)
                        this.$emit('submitNoIdHandle', this.vo)
                        this.dialogVisible = false
                    }
                })
            }, null, 1)
        },
        uploadAttact(list, vo) {
            this.doing = true
            var fileList = list.filter(item => !item.id)
            var _this = this
            console.log('list, vo', list, vo)
            return new Promise((resolve, reject) => {
                if (!fileList.length) {
                    resolve({ code: 'success', message: '未发现需要上传的附件。', result: [] })
                } else {
                    const array = []
                    fileList.forEach(item => {
                        const fd = new FormData()
                        fd.append('file', item.file.raw)
                        fd.append('module', 'ytRecord')
                        fd.append('attachsSize', item.file.size)
                        fd.append('busiDataId', vo.passenger.ytRecordId)
                        fd.append('attachsType', 'ATTACH')
                        fd.append('attachsName', item.file.name)
                        fd.append('uploadBy', _this.loginUser.personName)
                        fd.append('uploadById', _this.loginUser.userId)
                        array.push(this.$http({
                            method: 'POST',
                            // url: _this.moduleInfo.updateUrl.replace('update', 'upload'),
                            url: 'hygl/ytRecord/upload',
                            data: fd
                        }))
                    })
                    Promise.all(array).then(res => {
                        if (res.length === fileList.length) {
                            resolve({ code: 'success', message: '全部附件上传完成。', result: res })
                        }
                    })
                }
            })
        },
        toClose() {
            this.dialogVisible = false
        }

    }
}
</script>

<style scoped>

	.my {
		position: relative;
	}
	.my span {
		color:red;
		font-size:13px;
	}
	.my::after {
		position: absolute;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		content: " ";
		pointer-events: none;
		right: 0;
		bottom: 0;
		left: 16px;
		border-bottom: 1px solid #ebedf0;
		-webkit-transform: scaleY(.5);
		transform: scaleY(.5);
	}

</style>
